module.exports = __webpack_public_path__ + "static/img/about6.a3b991d2.jpeg";